import { makeInflect } from "../../../../core/utils/makeInflect.js";

export const inflectProduct = makeInflect("produkt", "produkty", "produktů");
